import React, { useCallback } from "react";

import { Controller } from "react-hook-form";
import { formatCurrency as utilFormatCurrency } from "../../../../utils/format";
// ... other imports

export default function ControlledField(props) {
  //console.log("ControlledField props:", props);
  const {
    name, control, InputComponent, label, placeholder, type = "text",
    className = "", cleanNumber, handleCurrencyBlur, onFormatted,
    handleCalAmount, defaultValue = "", inputProps = {}, disabled = false,
  } = props;

  const handleChange = useCallback((field, e) => {
    const raw = e?.target?.value ?? "";
    const cleaned = cleanNumber ? cleanNumber(raw) : raw;
    field.onChange(cleaned);
  }, [cleanNumber]);

  const handleBlur = useCallback(async (field, e) => {
    field.onBlur && field.onBlur(e);
    const current = e?.target?.value ?? field.value;
    const numeric = cleanNumber ? cleanNumber(String(current)) : String(current).replace(/[^0-9.]/g, "");

    if (!numeric) {
      try {
        // allow handleCurrencyBlur side-effects even if numeric empty
        if (handleCurrencyBlur) await handleCurrencyBlur(name, current);
      } catch (err) {
        if (process.env.NODE_ENV !== "production") console.warn("handleCurrencyBlur error", err);
      }
      return;
    }

    let formatted;
    try {
      if (handleCurrencyBlur) {
        const maybe = handleCurrencyBlur(name, current);
        // handle promise or plain string
        formatted = maybe && typeof maybe.then === "function" ? await maybe : maybe;
      }
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.warn("handleCurrencyBlur threw", err);
    }

    if (typeof formatted !== "string" || !formatted) {
      formatted = utilFormatCurrency(numeric);
    }

    field.onChange && field.onChange(formatted);
    onFormatted && onFormatted(name, formatted);

    try { handleCalAmount && handleCalAmount(); } catch (err) {
      if (process.env.NODE_ENV !== "production") console.warn("handleCalAmount error", err);
    }
  }, [cleanNumber, handleCurrencyBlur, onFormatted, handleCalAmount, name]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <InputComponent
          {...field}
          placeholder={placeholder}
          label={label}
          type={type}
          className={className}
          // don't reassign value if InputComponent consumes field correctly
          {...inputProps}
          onChange={(e) => handleChange(field, e)}
          onBlur={(e) => handleBlur(field, e)}
          disabled={disabled}
        />
      )}
    />
  );
}
